import { create } from './create';
import { deleteConnector } from './delete';
import { list } from './list';

export const connectors = {
  create,
  deleteConnector,
  list,
};
